import React, { useState, useEffect } from "react";
import { GET_KERNEL_LICENSE } from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import {
  Button,
  Row,
  Col,
  Container,
  Badge,
  Card,
  UncontrolledCollapse,
  CardBody,
  Input,
  Tooltip,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "reactstrap";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import moment from "moment";
import Pagination from "../../common/Pagination";

import { Link } from "react-router-dom";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import { getAgencyId } from "../../common/CommonFunctions";
import userLogo from "../../../images/user logo.png";
import { CSVLink } from "react-csv";
import generatePDF from "../../../components/Agency/Report/LicenseReportGenerte";
import { Info } from "../../common/Info";

function Kernellicense() {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const rowperpage = 10;

  const [currentpage, setCurrentPage] = useState(0);
  const [totalrecords, setTotalRecords] = useState(0);
  const [licenseStatus, setLicenseStatus] = useState("");
  const [email, setEmail] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };
  const headers = [
    { label: "Name", key: "userName" },
    { label: "Email", key: "email" },
    { label: "Plan Amount", key: "planAmount" },
    { label: "Valid From Date", key: "validFromDate" },
    { label: "Valid to Date", key: "validToDate" },
    { label: "Type of License", key: "typeofLicense" },
    { label: "License Issued Date", key: "licenseIssuedDate" },
    { label: "license Status", key: "licenseStatus" },
  ];
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const Export = () => {
    generatePDF(details);
  };
  

  const getKernalLicenseList = async (e) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_KERNEL_LICENSE,
      headers: authHeader(),
      params: {
        agencyId: getAgencyId(),
        isKennelLicense: true,
        offset: currentpage,
        count: rowperpage,
        licenseStatus: licenseStatus,
        email: email,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setDetails(data);
        setTotalRecords(totalCount);
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };
  const onHandleEmail = (e) => {
    const { value } = e.target;
    setEmail(value);
  };
  const Clear = () => {
    setLicenseStatus("");
    setEmail("");
  };
  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };
  const getLicenseStatus = (e) => {
    setCurrentPage(0);
    setLicenseStatus(e.target.value);
  };
  useEffect(() => {
    getKernalLicenseList();
  }, [currentpage, licenseStatus, email]);

  return (
    <div className="agency-wrapper">
      <Container fluid>
        <div className="page-title">
          <h4>
            Kennel License{" "}
            <Tooltip
              isOpen={id === "viewlicense" && tooltipOpen}
              target={"viewlicense"}
              toggle={() => tooltiptoggle("viewlicense")}
            >
              view license information
            </Tooltip>
            <span id={"viewlicense"}>
              <Info />
            </span>
          </h4>
          <div className="top-btn">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle color="danger" caret>
                Export
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={Export}>PDF</DropdownItem>
                <DropdownItem>
                  <CSVLink
                    filename={"License_report.csv"}
                    data={details}
                    headers={headers}
                  >
                    CSV
                  </CSVLink>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Button color="link" id="toggler">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.371"
                height="14.371"
                viewBox="0 0 14.371 14.371"
              >
                <path
                  id="Icon_awesome-filter"
                  data-name="Icon awesome-filter"
                  d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                  fill="#1b3e6f"
                />
              </svg>
            </Button>
          </div>
        </div>
        <Row>
          <Col sm="12" xl={{ size: 6, offset: 3 }}>
            <UncontrolledCollapse className="mt-4" toggler="#toggler">
              <Card>
                <CardBody>
                  <Row>
                    <Col md="4">
                      <Input
                        type="text"
                        onChange={onHandleEmail}
                        value={email}
                        name="Email"
                        placeholder="Search Email"
                      />
                    </Col>
                    <Col md="4">
                      <Input
                        type="select"
                        name="License Status"
                        onChange={(e) => getLicenseStatus(e)}
                      >
                        <option value="">Change Status</option>
                        <option value="Pending">Pending</option>
                        <option value="Cancelled">Cancelled</option>
                        <option value="Rejected">Rejected</option>
                        <option value="License Generated">
                          License Generated
                        </option>
                        <option value="License Approved">
                          License Approved
                        </option>
                        <option value="License Issued">License Issued</option>
                        <option value="Payment Completed">
                          Payment Completed
                        </option>
                          <option value="Pay with Agency">
                            Pay with Agency
                          </option>
                      </Input>
                    </Col>
                    <Col md="4">
                      <Button color="danger" onClick={Clear} block>
                        Clear
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </UncontrolledCollapse>
          </Col>
        </Row>

        <Row className="mt-4">
          {loading ? <CustomPageLoading /> : ""}
          {loading ? (
            ""
          ) : details.length === 0 ? (
            <>
              <Col>
                <center>No Records Found</center>
              </Col>
            </>
          ) : (
            details.map((data) => {
              const {
                planName,
                licenseStatus,
                licenseIssuedDate,
                profileImage,
                email,
                isLifeTimePlan,
                planAmount,
                licensePlanId,
                dogLicenseId,
                planDuration,
                userName,
              } = data;
              return (
                <Col md="6" lg="6" xl="4" key={dogLicenseId}>
                  <div className="license-box">
                    <span className="date">
                      {licenseIssuedDate
                        ? moment(licenseIssuedDate).format("MM/DD/YYYY")
                        : ""}
                    </span>
                    <div className="dogImg">
                      <img src={profileImage ? profileImage : userLogo} alt=""/>
                    </div>

                    <h4>{planName ? planName : "N/A"}</h4>

                    <div className="mt-4">
                      <div>
                        <hr className="my-2" />
                        <div className="row align-items-center">
                          <div className="col">
                            <h6 className="text-sm mb-0">User</h6>
                          </div>
                          <div className="col-auto">
                            <span className="text-sm">
                              {" "}
                              {userName ? userName : "N/A"}
                            </span>
                          </div>
                        </div>
                        <hr className="my-2" />
                        <div className="row align-items-center">
                          <div className="col">
                            <h6 className="text-sm mb-0">Email</h6>
                          </div>
                          <div className="col-auto">
                            <span className="text-sm">
                              {email ? email : "N/A"}
                            </span>
                          </div>
                        </div>
                        <hr className="my-2" />
                      </div>
                    </div>

                    <div className="plan">
                      <span>
                        {isLifeTimePlan ? (
                          <>
                            $
                            {planAmount
                              ? parseFloat(planAmount).toFixed(2)
                              : "N/A"}{" "}
                            /{" "}
                            {isLifeTimePlan
                              ? "Lifetime plan"
                              : parseInt(planDuration) * 12 + "month"}
                          </>
                        ) : (
                          "Lifetime plan"
                        )}
                      </span>
                    </div>

                    {
                      <Badge
                        className={
                          licenseStatus === "License Issued"
                            ? "badge-pay-complete"
                            : licenseStatus === "Pending"
                            ? "badge-success-pen"
                            : licenseStatus === "License Approved"
                            ? "badge-success-apr"
                            : licenseStatus === "Rejected"
                            ? "badge-danger-soft"
                            : licenseStatus === "Payment Completed"
                            ? "badge-primary-soft"
                            : licenseStatus === "License Generated"
                            ? "badge-success-gen"
                            : licenseStatus === "Cancelled"
                            ? "badge-danger-soft"
                            : ""
                        }
                      >
                        {" "}
                        {licenseStatus}{" "}
                      </Badge>
                    }

                    <div className="card-footer mt-3">
                      <div className="actions d-flex justify-content-center px-4">
                        <Link
                          to={{
                            pathname: `${"/agency/view-license"}/${licensePlanId}/${dogLicenseId}`,
                          }}
                        >
                          <Button
                            className="action-item"
                            color="primary"
                            size="sm"
                          >
                            View
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </Col>
              );
            })
          )}
        </Row>
      </Container>
      <div className="d-flex flex-row py-4 justify-content-end">
        <Pagination
          itemClass="page-item"
          linkClass="page-link"
          itemsCountPerPage={rowperpage}
          totalItemsCount={totalrecords}
          activePage={currentpage + 1}
          onChange={onPageChange}
        />
      </div>
    </div>
  );
}
export default Kernellicense;
